import type { OperationalCompletionSnapshotPayload } from './completionSnapshot';

export function isTerminalCompleted(
  routeStatus: string | null | undefined,
  snapshot?: OperationalCompletionSnapshotPayload | null
): boolean {
  if (snapshot != null) return true;
  return String(routeStatus || '').toUpperCase() === 'COMPLETED';
}

/** Locked only after operational snapshot — not on premature route.status projection. */
export function isCompletionLocked(params: {
  routeStatus: string | null | undefined;
  snapshot: OperationalCompletionSnapshotPayload | null;
}): boolean {
  return params.snapshot != null;
}

export function canEditCompletion(params: {
  routeStatus: string | null | undefined;
  snapshot: OperationalCompletionSnapshotPayload | null;
}): boolean {
  return !isCompletionLocked(params);
}

export function canFinalizeCompletion(params: {
  routeStatus: string | null | undefined;
  snapshot: OperationalCompletionSnapshotPayload | null;
  executionComplete: boolean;
}): boolean {
  if (isCompletionLocked(params)) return false;
  return params.executionComplete;
}

export function isReadyForOperationalCompletion(routeStatus: string | null | undefined): boolean {
  const norm = String(routeStatus || '').toUpperCase();
  return norm === 'READY_FOR_COMPLETION' || norm === 'READY FOR COMPLETION';
}
